import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ReactionHeartIcon = (props: IconProps) => (
  <Icon width="32px" height="32px" viewBox="0 0 32 32" {...props}>
    <circle cx="16" cy="16" r="16" fill="#FDECEC" />
    <path
      fill="#E94545"
      d="m16 24.311-1.289-1.173c-4.578-4.151-7.6-6.89-7.6-10.25C7.111 10.152 9.262 8 12 8c1.547 0 3.031.72 4 1.858A5.323 5.323 0 0 1 20 8c2.738 0 4.889 2.151 4.889 4.889 0 3.36-3.022 6.098-7.6 10.258L16 24.31Z"
    />
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M5.333 5.334h21.333v21.333H5.333z" />
      </clipPath>
    </defs>
  </Icon>
);

export default memo(ReactionHeartIcon);
